
import React from 'react'
import './Excerpts.css';

function Excerpts() {
  return (
    <div style={{marginTop:"25px"}}>
      <section
    className="elementor-section elementor-top-section elementor-element elementor-element-873c39e animated-fast elementor-section-boxed elementor-section-height-default elementor-section-height-default animated fadeIn"
    data-id="873c39e"
    data-element_type="section"
    data-settings='{"animation":"fadeIn","animation_delay":100,"wdt_bg_image":{"url":"","id":"","size":""},"wdt_bg_image_laptop":{"url":"","id":"","size":""},"wdt_bg_image_tablet_extra":{"url":"","id":"","size":""},"wdt_bg_image_tablet":{"url":"","id":"","size":""},"wdt_bg_image_mobile_extra":{"url":"","id":"","size":""},"wdt_bg_image_mobile":{"url":"","id":"","size":""},"wdt_bg_position":"center center","wdt_animation_effect":"none"}'
  >
    <div className="elementor-container elementor-column-gap-no">
      <div
        className="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-3d1fee9"
        data-id="3d1fee9"
        data-element_type="column"
      >
        <div className="elementor-widget-wrap elementor-element-populated">
          <section
            className="elementor-section elementor-inner-section elementor-element elementor-element-c8f1d85 elementor-section-full_width elementor-section-content-middle elementor-section-height-default elementor-section-height-default"
            data-id="c8f1d85"
            data-element_type="section"
            data-settings='{"wdt_bg_image":{"url":"","id":"","size":""},"wdt_bg_image_laptop":{"url":"","id":"","size":""},"wdt_bg_image_tablet_extra":{"url":"","id":"","size":""},"wdt_bg_image_tablet":{"url":"","id":"","size":""},"wdt_bg_image_mobile_extra":{"url":"","id":"","size":""},"wdt_bg_image_mobile":{"url":"","id":"","size":""},"wdt_bg_position":"center center","wdt_animation_effect":"none"}'
          >
            <div className="elementor-container elementor-column-gap-no">
              <div
                className="elementor-column elementor-col-50 elementor-inner-column elementor-element elementor-element-32745c7 animated-fast animated bounceInLeft"
                data-id="32745c7"
                data-element_type="column"
                data-settings='{"animation":"bounceInLeft","animation_delay":100}'
              >
                <div className="elementor-widget-wrap elementor-element-populated">
                  <div
                    className="elementor-element elementor-element-1f24173 start elementor-widget__width-initial elementor-widget-tablet_extra__width-inherit elementor-widget-mobile_extra__width-initial elementor-widget-mobile__width-inherit elementor-widget elementor-widget-wdt-heading"
                    data-id="1f24173"
                    data-element_type="widget"
                    data-settings='{"wdt_animation_effect":"none"}'
                    data-widget_type="wdt-heading.default"
                  >
                    <div className="elementor-widget-container">
                      <div
                        className="wdt-heading-holder"
                        id="wdt-heading-1f24173"
                      >
                        <div className="wdt-heading-subtitle-wrapper wdt-heading-align-center">
                          <span className="wdt-heading-subtitle" style={{color:"green"}}>
                            Our Experts
                          </span>
                        </div>
                        <h2 className="wdt-heading-title-wrapper wdt-heading-align-center wdt-heading-deco-wrapper">
                          <span className="wdt-heading-title-experts">
                            Incredible People Behind Incredible Students.
                          </span>
                        </h2>
                      </div>{" "}
                    </div>
                  </div>
                  <div
                    className="elementor-element elementor-element-b54e244 elementor-widget__width-auto elementor-hidden-tablet_extra elementor-hidden-tablet elementor-hidden-mobile_extra elementor-hidden-mobile animated-fast elementor-view-default elementor-widget elementor-widget-icon animated bounceInUp"
                    data-id="b54e244"
                    data-element_type="widget"
                    data-settings='{"_animation":"bounceInUp","_animation_delay":500,"wdt_animation_effect":"none"}'
                    data-widget_type="icon.default"
                  >
                    <div className="elementor-widget-container">
                      <div className="elementor-icon-wrapper">
                        <div className="elementor-icon">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                     
                            x="0px"
                            y="0px"
                            viewBox="0 0 100 100"
                            style={{ enableBackground: "new 0 0 100 100" }}
                           
                          >
                            {" "}
                            <style
                              type="text/css"
                              dangerouslySetInnerHTML={{
                                __html:
                                  "\t.glit-star-0{fill:#F0BA46;}\t.glit-star-1{fill:#2F2F2F;}\t.glit-star-2{fill:#E75D30;}\t.glit-star-3{fill:#EEA7AF;}\t.glit-star-4{fill:#5AAD65;}\t"
                              }}
                            />{" "}
                            <g>
                              {" "}
                              <g className="wdt-glit-stars-1">
                                {" "}
                                <path
                                  className="glit-star-0"
                                  d="M1.3,68.9c11.3,5.8,16,10.5,21.8,21.8c5.8-11.3,10.5-16,21.8-21.8c-11.3-5.8-16-10.5-21.8-21.8   C17.3,58.4,12.6,63.1,1.3,68.9z"
                                />{" "}
                                <path
                                  className="glit-star-1"
                                  d="M0.9,69.6c4.6,2.4,9.1,5,12.8,8.7s6.3,8.2,8.7,12.8c0.3,0.5,1.2,0.5,1.4,0   c2.4-4.6,5-9.1,8.7-12.8s8.2-6.3,12.8-8.7c0.5-0.3,0.5-1.2,0-1.4c-4.6-2.4-9.1-5-12.8-8.7c-3.7-3.7-6.3-8.2-8.7-12.8   c-0.3-0.5-1.2-0.5-1.4,0c-2.4,4.6-5,9.1-8.7,12.8c-3.7,3.7-8.2,6.3-12.8,8.7c-1,0.5-0.1,1.9,0.8,1.4c3.8-2,7.5-4.1,10.8-6.8   c2.9-2.4,5.4-5.3,7.4-8.5c1.4-2.2,2.7-4.5,3.9-6.8h-1.4c2,3.8,4.1,7.5,6.8,10.8c2.4,2.9,5.3,5.4,8.5,7.4c2.2,1.4,4.5,2.7,6.8,3.9   v-1.4c-3.8,2-7.5,4.1-10.8,6.8c-2.9,2.4-5.4,5.3-7.4,8.5c-1.4,2.2-2.7,4.5-3.9,6.8h1.4c-2-3.8-4.1-7.5-6.8-10.8   c-2.4-2.9-5.3-5.4-8.5-7.4c-2.2-1.4-4.5-2.7-6.8-3.9C0.8,67.7,0,69.1,0.9,69.6z"
                                />{" "}
                              </g>{" "}
                              <g className="wdt-glit-stars-2">
                                {" "}
                                <path
                                  className="glit-star-2"
                                  d="M40.8,25.1c6.8,3.5,9.6,6.3,13.1,13.1c3.5-6.8,6.3-9.6,13.1-13.1c-6.8-3.5-9.6-6.3-13.1-13.1   C50.3,18.8,47.5,21.7,40.8,25.1z"
                                />{" "}
                                <path
                                  className="glit-star-1"
                                  d="M40.3,25.8c2.7,1.4,5.4,3,7.6,5.2c2.2,2.2,3.8,4.9,5.2,7.6c0.3,0.5,1.2,0.5,1.4,0   c1.4-2.7,3-5.4,5.2-7.6c2.2-2.2,4.9-3.8,7.6-5.2c0.5-0.3,0.5-1.2,0-1.4c-2.7-1.4-5.4-3-7.6-5.2c-2.2-2.2-3.8-4.9-5.2-7.6   c-0.3-0.5-1.2-0.5-1.4,0c-1.4,2.7-3,5.4-5.2,7.6c-2.2,2.2-4.9,3.8-7.6,5.2c-1,0.5-0.1,1.9,0.8,1.4c2.9-1.5,5.7-3.1,7.9-5.4   c2.3-2.3,4-5.1,5.4-7.9h-1.4c1.5,2.9,3.1,5.7,5.4,7.9c2.3,2.3,5.1,4,7.9,5.4v-1.4c-2.9,1.5-5.7,3.1-7.9,5.4   c-2.3,2.3-4,5.1-5.4,7.9h1.4c-1.5-2.9-3.1-5.7-5.4-7.9c-2.3-2.3-5.1-4-7.9-5.4C40.2,23.9,39.4,25.4,40.3,25.8z"
                                />{" "}
                              </g>{" "}
                              <g className="wdt-glit-stars-3">
                                {" "}
                                <path
                                  className="glit-star-3"
                                  d="M83.7,16.8c3.9,2,5.5,3.6,7.5,7.5c2-3.9,3.6-5.5,7.5-7.5c-3.9-2-5.5-3.6-7.5-7.5   C89.2,13.2,87.6,14.8,83.7,16.8z"
                                />{" "}
                                <path
                                  className="glit-star-1"
                                  d="M83.3,17.5c1.5,0.8,3.1,1.7,4.3,2.9c1.2,1.2,2.1,2.7,2.9,4.3c0.3,0.5,1.2,0.5,1.4,0   c0.8-1.5,1.7-3.1,2.9-4.3c1.2-1.2,2.7-2.1,4.3-2.9c0.5-0.3,0.5-1.2,0-1.4c-1.5-0.8-3.1-1.7-4.3-2.9c-1.2-1.2-2.1-2.7-2.9-4.3   c-0.3-0.5-1.2-0.5-1.4,0c-0.8,1.5-1.7,3.1-2.9,4.3c-1.2,1.2-2.7,2.1-4.3,2.9c-1,0.5-0.1,1.9,0.8,1.4c1.7-0.9,3.3-1.8,4.6-3.2   c1.3-1.3,2.3-3,3.2-4.6h-1.4c0.9,1.7,1.8,3.3,3.2,4.6c1.3,1.3,3,2.3,4.6,3.2v-1.4c-1.7,0.9-3.3,1.8-4.6,3.2   c-1.3,1.3-2.3,3-3.2,4.6h1.4c-0.9-1.7-1.8-3.3-3.2-4.6c-1.3-1.3-3-2.3-4.6-3.2C83.2,15.6,82.3,17,83.3,17.5z"
                                />{" "}
                              </g>{" "}
                              <g className="wdt-glit-stars-4">
                                {" "}
                                <path
                                  className="glit-star-4"
                                  d="M52,53.6c5.1,2.6,7.3,4.8,9.9,9.9c2.6-5.1,4.8-7.3,9.9-9.9c-5.1-2.6-7.3-4.8-9.9-9.9   C59.3,48.9,57.2,51,52,53.6z"
                                />{" "}
                                <path
                                  className="glit-star-1"
                                  d="M51.6,54.4c2.1,1.1,4.1,2.2,5.7,3.9c1.6,1.6,2.8,3.7,3.9,5.7c0.3,0.5,1.2,0.5,1.4,0   c1.1-2.1,2.2-4.1,3.9-5.7c1.6-1.6,3.7-2.8,5.7-3.9c0.5-0.3,0.5-1.2,0-1.4c-2.1-1.1-4.1-2.2-5.7-3.9c-1.6-1.6-2.8-3.7-3.9-5.7   c-0.3-0.5-1.2-0.5-1.4,0c-1.1,2.1-2.2,4.1-3.9,5.7c-1.6,1.6-3.7,2.8-5.7,3.9c-1,0.5-0.1,1.9,0.8,1.4c2.2-1.1,4.3-2.4,6.1-4.1   c1.7-1.7,3-3.9,4.1-6.1h-1.4c1.1,2.2,2.4,4.3,4.1,6.1c1.7,1.7,3.9,3,6.1,4.1v-1.4c-2.2,1.1-4.3,2.4-6.1,4.1   c-1.7,1.7-3,3.9-4.1,6.1h1.4c-1.1-2.2-2.4-4.3-4.1-6.1c-1.7-1.7-3.9-3-6.1-4.1C51.5,52.4,50.7,53.9,51.6,54.4z"
                                />{" "}
                              </g>{" "}
                            </g>
                          </svg>{" "}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div
                className="elementor-column elementor-col-50 elementor-inner-column elementor-element elementor-element-759d602 animated-fast animated bounceInRight"
                data-id="759d602"
                data-element_type="column"
                data-settings='{"animation":"bounceInRight","animation_delay":100}'
              >
                <div className="elementor-widget-wrap elementor-element-populated">
                  <div
                    className="elementor-element elementor-element-a6e677e start elementor-widget-mobile_extra__width-initial elementor-widget-mobile__width-inherit elementor-widget elementor-widget-wdt-heading"
                    data-id="a6e677e"
                    data-element_type="widget"
                    data-settings='{"wdt_animation_effect":"none"}'
                    data-widget_type="wdt-heading.default"
                  >
                    <div className="elementor-widget-container">
                      <div
                        className="wdt-heading-holder"
                        id="wdt-heading-a6e677e"
                      >
                        <div className="wdt-heading-content-wrapper-sentence">
                          Nec feugiat in fermentum posuere urna. Quam nulla
                          porttitor massa id neque aliquam vestibulum morbi
                          blandit. Aliquam faucibus purus in massa tempor nec
                          feugiat. Pharetra vel turpis nunc eget. Proin libero
                          nunc consequat interdum varius sit amet..
                        </div>
                      </div>{" "}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
          <section
            className="elementor-section elementor-inner-section elementor-element elementor-element-2a8afcc elementor-section-full_width elementor-section-content-middle animated-fast elementor-section-height-default elementor-section-height-default animated bounceInUp"
            data-id="2a8afcc"
            data-element_type="section"
            data-settings='{"animation":"bounceInUp","animation_delay":0,"wdt_bg_image":{"url":"","id":"","size":""},"wdt_bg_image_laptop":{"url":"","id":"","size":""},"wdt_bg_image_tablet_extra":{"url":"","id":"","size":""},"wdt_bg_image_tablet":{"url":"","id":"","size":""},"wdt_bg_image_mobile_extra":{"url":"","id":"","size":""},"wdt_bg_image_mobile":{"url":"","id":"","size":""},"wdt_bg_position":"center center","wdt_animation_effect":"none"}'
          >
            <div className="elementor-container elementor-column-gap-no">
              <div
                className="elementor-column elementor-col-100 elementor-inner-column elementor-element elementor-element-d24131a"
                data-id="d24131a"
                data-element_type="column"
              >
                <div className="elementor-widget-wrap elementor-element-populated">
                  <div
                    className="elementor-element elementor-element-04d93c0 elementor-widget__width-auto elementor-absolute elementor-hidden-tablet elementor-hidden-mobile_extra elementor-hidden-mobile animated-fast elementor-widget elementor-widget-image animated bounceIn"
                    data-id="04d93c0"
                    data-element_type="widget"
                    data-settings='{"_position":"absolute","_animation":"bounceIn","_animation_delay":1000,"wdt_animation_effect":"none"}'
                    data-widget_type="image.default"
                  >
                    {/* <div className="elementor-widget-container">
                      <img
                        loading="lazy"
                        decoding="async"
                        width={1000}
                        height={1076}
                        src="https://dtthemes.kinsta.cloud/a-for-apple/wp-content/uploads/sites/2/2024/01/icbox-filler-img-02.webp"
                        className="attachment-full size-full wp-image-1273"
                        alt=""
                        srcSet="https://dtthemes.kinsta.cloud/a-for-apple/wp-content/uploads/sites/2/2024/01/icbox-filler-img-02.webp 1000w, https://dtthemes.kinsta.cloud/a-for-apple/wp-content/uploads/sites/2/2024/01/icbox-filler-img-02-279x300.webp 279w, https://dtthemes.kinsta.cloud/a-for-apple/wp-content/uploads/sites/2/2024/01/icbox-filler-img-02-952x1024.webp 952w, https://dtthemes.kinsta.cloud/a-for-apple/wp-content/uploads/sites/2/2024/01/icbox-filler-img-02-768x826.webp 768w"
                        sizes="(max-width: 1000px) 100vw, 1000px"
                      />{" "}
                    </div> */}
                  </div>
                  <div
                    className="elementor-element elementor-element-8809041 elementor-widget__width-auto elementor-absolute elementor-hidden-tablet elementor-hidden-mobile_extra elementor-hidden-mobile animated-fast elementor-view-default elementor-widget elementor-widget-icon animated bounceInUp"
                    data-id={8809041}
                    data-element_type="widget"
                    data-settings='{"_position":"absolute","_animation":"bounceInUp","_animation_delay":800,"wdt_animation_effect":"none"}'
                    data-widget_type="icon.default"
                  >
                    <div className="elementor-widget-container">
                      <div className="elementor-icon-wrapper">
                        <div className="elementor-icon">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            xmlnsXlink="http://www.w3.org/1999/xlink"
                            x="0px"
                            y="0px"
                            viewBox="0 0 100 100"
                            style={{ enableBackground: "new 0 0 100 100" }}
                            xmlSpace="preserve"
                          >
                            {" "}
                            <g>
                              {" "}
                              <path d="M21.9,52.8c-0.2-0.1-0.4-0.2-0.6-0.3c-3.1-1.6-6.3-3.1-9.4-4.7c-2.2-1.1-4.2-2.5-5.9-4.3c-1.1-1.1-2-2.4-2.4-4  c-0.7-2.8,0.6-6.9,4.1-8.6c1.3-0.7,2.8-1,4.2-1.2c3.6-0.4,7,0.3,10.4,1.3c3.2,1,6.3,2.4,9.4,3.8c0.5,0.2,1,0.4,1.5,0.7  c0.1-0.5,0.2-1,0.3-1.5c1-4.8,2.1-9.6,3.9-14.2c1.1-2.9,2.4-5.7,4-8.5c1-1.8,2.3-3.5,4-4.9c1.3-1.1,2.8-1.8,4.6-2  c2.2-0.3,4.2,0.4,5.9,1.8c1.6,1.3,2.7,3,3.5,4.9c0.9,2.1,1.4,4.3,1.7,6.6c0.4,3.7,0.3,7.3-0.1,11c-0.3,2.4-0.6,4.9-0.9,7.3  c0,0,0,0.1,0,0.2c0.6-0.1,1.2-0.2,1.7-0.3c1-0.2,2-0.7,2.9-1.2c4-2,8.1-3.9,12.3-5.3c2.3-0.8,4.6-1.3,7-1.5  c1.2-0.1,2.3-0.2,3.5-0.2c2.3,0.1,4.5,0.8,6.3,2.3c2.2,1.8,3,4.1,2.7,6.9c-0.2,2.1-1,3.9-2.1,5.6c-1.9,3.2-4.5,5.8-7.4,8  c-4.2,3.3-9,5.5-14.1,7c-2,0.6-4,1.1-6,1.7c-0.1,0-0.2,0.1-0.3,0.1c0.1,0.7,0.3,1.3,0.6,1.9c0.3,0.5,0.7,1,1.1,1.5  c1.7,1.7,2.9,3.6,4.1,5.6c1.6,2.8,2.9,5.8,3.5,9c0.7,3.5,0.8,7-0.2,10.5c-1.2,4.3-4.2,6.9-8.5,7.8c-2.3,0.5-4.5,0-6.6-1.1  c-2.2-1.1-4.1-2.6-5.9-4.3c-3-2.9-5.3-6.3-7.2-9.9c-0.9-1.8-1.7-3.7-2.5-5.5c-0.3-0.7-0.5-1.6-0.8-2.3c-0.4-1.2-1.1-2.2-2-2.8  c-0.1,0.1-0.2,0.1-0.2,0.2c-1.7,1.7-3.4,3.4-5.2,5c-2.4,2.2-5,4-8,5.3c-2.6,1.1-5.3,1.6-8.1,1.5c-2.7-0.1-5.3-0.8-7.5-2.6  c-2.3-1.8-3.5-4.2-3.7-7.1c-0.2-2.9,0.6-5.5,2-8c1.3-2.3,3-4.2,4.8-5.9c0.9-0.9,1.9-1.7,2.9-2.3c0.9-0.6,1.7-1.4,2.2-2.4  C21.8,53,21.8,52.9,21.9,52.8z" />{" "}
                            </g>
                          </svg>{" "}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    className="elementor-element elementor-element-2b46930 elementor-widget elementor-widget-dtlms-widget-default-instructor-listing"
                    data-id="2b46930"
                    data-element_type="widget"
                    data-settings='{"wdt_animation_effect":"none"}'
                    data-widget_type="dtlms-widget-default-instructor-listing.default"
                  >
                    <div className="elementor-widget-container">
                      <div className="dtlms-instructor-item dtlms-column dtlms-one-fourth first type2 wdt-custom-instructors default">
                        <div className="dtlms-instructor-item-image-wrapper">
                          <a
                            href="https://dtthemes.kinsta.cloud/a-for-apple/author/aurora/"
                            rel="author"
                          >
                            <img
                              decoding="async"
                              src="https://dtthemes.kinsta.cloud/a-for-apple/wp-content/uploads/sites/2/2024/01/team-02.webp"
                              alt="Instructor Image"
                              title="Instructor Image"
                            />
                          </a>
                          <div className="dtlms-team-social-links">
                            <ul className="dtlms-team-social">
                              <li>
                                <a
                                  className="fab fa-twitter"
                                  href="https://twitter.com/i/flow/login"
                                />
                              </li>
                              <li>
                                <a
                                  className="fab fa-facebook-f"
                                  href="https://www.facebook.com/"
                                />
                              </li>
                              <li>
                                <a
                                  className="fab fa-youtube"
                                  href="https://www.youtube.com/"
                                />
                              </li>
                              <li>
                                <a
                                  className="fab fa-instagram"
                                  href="https://www.instagram.com/accounts/login/"
                                />
                              </li>
                            </ul>
                          </div>
                        </div>
                        <div className="dtlms-instructor-item-meta-data">
                          <h4>
                            <a
                              href="https://dtthemes.kinsta.cloud/a-for-apple/author/aurora/"
                              rel="author"
                            >
                              Aurora Jackson
                            </a>
                          </h4>
                          <h5>English </h5>
                        </div>
                      </div>
                      <div className="dtlms-instructor-item dtlms-column dtlms-one-fourth  type2 wdt-custom-instructors default">
                        <div className="dtlms-instructor-item-image-wrapper">
                          <a
                            href="https://dtthemes.kinsta.cloud/a-for-apple/author/cosmi/"
                            rel="author"
                          >
                            <img
                              decoding="async"
                              src="https://dtthemes.kinsta.cloud/a-for-apple/wp-content/uploads/sites/2/2024/01/team-03.webp"
                              alt="Instructor Image"
                              title="Instructor Image"
                            />
                          </a>
                          <div className="dtlms-team-social-links">
                            <ul className="dtlms-team-social">
                              <li>
                                <a
                                  className="fab fa-twitter"
                                  href="https://twitter.com/i/flow/login"
                                />
                              </li>
                              <li>
                                <a
                                  className="fab fa-facebook-f"
                                  href="https://www.facebook.com/"
                                />
                              </li>
                              <li>
                                <a
                                  className="fab fa-youtube"
                                  href="https://www.youtube.com/"
                                />
                              </li>
                              <li>
                                <a
                                  className="fab fa-instagram"
                                  href="https://www.instagram.com/accounts/login/"
                                />
                              </li>
                            </ul>
                          </div>
                        </div>
                        <div className="dtlms-instructor-item-meta-data">
                          <h4>
                            <a
                              href="https://dtthemes.kinsta.cloud/a-for-apple/author/cosmi/"
                              rel="author"
                            >
                              cosmi
                            </a>
                          </h4>
                          <h5>French</h5>
                        </div>
                      </div>
                      <div className="dtlms-instructor-item dtlms-column dtlms-one-fourth  type2 wdt-custom-instructors default">
                        <div className="dtlms-instructor-item-image-wrapper">
                          <a
                            href="https://dtthemes.kinsta.cloud/a-for-apple/author/debora/"
                            rel="author"
                          >
                            <img
                              decoding="async"
                              src="https://dtthemes.kinsta.cloud/a-for-apple/wp-content/uploads/sites/2/2024/01/team-04.webp"
                              alt="Instructor Image"
                              title="Instructor Image"
                            />
                          </a>
                          <div className="dtlms-team-social-links">
                            <ul className="dtlms-team-social">
                              <li>
                                <a
                                  className="fab fa-twitter"
                                  href="https://twitter.com/i/flow/login"
                                />
                              </li>
                              <li>
                                <a
                                  className="fab fa-facebook-f"
                                  href="https://www.facebook.com/"
                                />
                              </li>
                              <li>
                                <a
                                  className="fab fa-youtube"
                                  href="https://www.youtube.com/"
                                />
                              </li>
                              <li>
                                <a
                                  className="fab fa-instagram"
                                  href="https://www.instagram.com/accounts/login/"
                                />
                              </li>
                            </ul>
                          </div>
                        </div>
                        <div className="dtlms-instructor-item-meta-data">
                          <h4>
                            <a
                              href="https://dtthemes.kinsta.cloud/a-for-apple/author/debora/"
                              rel="author"
                            >
                              debora
                            </a>
                          </h4>
                          <h5>Classroom Management</h5>
                        </div>
                      </div>
                      <div className="dtlms-instructor-item dtlms-column dtlms-one-fourth  type2 wdt-custom-instructors default">
                        <div className="dtlms-instructor-item-image-wrapper">
                          <a
                            href="https://dtthemes.kinsta.cloud/a-for-apple/author/elspeth/"
                            rel="author"
                          >
                            <img
                              decoding="async"
                              src="https://dtthemes.kinsta.cloud/a-for-apple/wp-content/uploads/sites/2/2024/02/teacher-image-5.webp"
                              alt="Instructor Image"
                              title="Instructor Image"
                            />
                          </a>
                          <div className="dtlms-team-social-links">
                            <ul className="dtlms-team-social">
                              <li>
                                <a
                                  className="fab fa-twitter"
                                  href="https://twitter.com/i/flow/login"
                                />
                              </li>
                              <li>
                                <a
                                  className="fab fa-facebook-f"
                                  href="https://www.facebook.com/"
                                />
                              </li>
                              <li>
                                <a
                                  className="fab fa-youtube"
                                  href="https://www.youtube.com/"
                                />
                              </li>
                              <li>
                                <a
                                  className="fab fa-instagram"
                                  href="https://www.instagram.com/accounts/login/"
                                />
                              </li>
                            </ul>
                          </div>
                        </div>
                        <div className="dtlms-instructor-item-meta-data">
                          <h4>
                            <a
                              href="https://dtthemes.kinsta.cloud/a-for-apple/author/elspeth/"
                              rel="author"
                            >
                              elspeth
                            </a>
                          </h4>
                          <h5>Montessori</h5>
                        </div>
                      </div>{" "}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
    </div>
  </section>
  </div>
  )
}

export default Excerpts